import { render } from "./UseVoucher.vue?vue&type=template&id=675d8ea6&scoped=true"
import script from "./UseVoucher.vue?vue&type=script&lang=js"
export * from "./UseVoucher.vue?vue&type=script&lang=js"

import "./UseVoucher.vue?vue&type=style&index=0&id=675d8ea6&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675d8ea6"]])

export default __exports__